<script setup>
/**
 * Jednotný nadpis sekce. Centralizuje typografickou škálu nadpisů,
 * aby se velikosti napříč sekcemi nemohly rozejít.
 *
 * - `title`   povinný text nadpisu
 * - `eyebrow` volitelný malý uppercase popisek nad nadpisem
 * - `lede`    volitelný úvodní odstavec pod nadpisem
 * - `as`      tag nadpisu (default h2)
 * - `id`      volitelné id pro anchor/scroll
 *
 * Doplňkový obsah (např. audience toggle) lze vložit přes default slot.
 */
defineProps({
    title: { type: String, required: true },
    eyebrow: { type: String, default: '' },
    lede: { type: String, default: '' },
    as: { type: String, default: 'h2' },
    id: { type: String, default: '' },
})
</script>

<template>
    <div>
        <p
            class="text-accent-600 text-sm font-semibold tracking-[0.18em] uppercase"
            v-if="eyebrow"
        >
            {{ eyebrow }}
        </p>

        <component
            class="text-brand-900 text-4xl leading-[1.1] font-extrabold tracking-tight md:text-5xl lg:text-6xl"
            :class="eyebrow ? 'mt-3' : ''"
            :id="id || undefined"
            :is="as"
        >
            {{ title }}
        </component>

        <p
            class="mt-6 text-lg leading-relaxed text-zinc-600"
            v-if="lede"
        >
            {{ lede }}
        </p>

        <slot />
    </div>
</template>
